export const getLuminanceHEXColor = (hexColor: string) => {
  // Validate hex color format
  if (!hexColor || !hexColor.startsWith('#') || (hexColor.length !== 7 && hexColor.length !== 4)) {
    return 1.0
  }

  // Clean hex color format
  let cleanedHexColor = hexColor
  if (hexColor.length === 4) {
    cleanedHexColor = `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
  }

  // Convert hex to RGB
  const r = parseInt(cleanedHexColor.substring(1, 3), 16)
  const g = parseInt(cleanedHexColor.substring(3, 5), 16)
  const b = parseInt(cleanedHexColor.substring(5, 7), 16)

  // Check for NaN values
  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return 1.0
  }

  // Normalize RGB values
  const R = r / 255
  const G = g / 255
  const B = b / 255

  // Apply sRGB to linear RGB conversion
  const sR = R <= 0.03928 ? R / 12.92 : ((R + 0.055) / 1.055) ** 2.4
  const sG = G <= 0.03928 ? G / 12.92 : ((G + 0.055) / 1.055) ** 2.4
  const sB = B <= 0.03928 ? B / 12.92 : ((B + 0.055) / 1.055) ** 2.4

  // Calculate luminance
  return 0.2126 * sR + 0.7152 * sG + 0.0722 * sB
}
